module.exports = __webpack_public_path__ + "static/media/DOPPLE-DOLLY-LP.45c3f2c2.svg";